import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

/**
 * TouchableItem renders a touchable that looks native on both iOS and Android.
 *
 * It provides an abstraction on top of TouchableNativeFeedback and
 * TouchableOpacity.
 *
 * On iOS you can pass the props of TouchableOpacity, on Android pass the props
 * of TouchableNativeFeedback.
 */
import React from 'react';
import { Platform, TouchableNativeFeedback, TouchableOpacity, View } from 'react-native';
var ANDROID_VERSION_LOLLIPOP = 21;

var TouchableItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TouchableItem, _React$Component);

  function TouchableItem() {
    _classCallCheck(this, TouchableItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(TouchableItem).apply(this, arguments));
  }

  _createClass(TouchableItem, [{
    key: "render",
    value: function render() {
      /*
       * TouchableNativeFeedback.Ripple causes a crash on old Android versions,
       * therefore only enable it on Android Lollipop and above.
       *
       * All touchables on Android should have the ripple effect according to
       * platform design guidelines.
       * We need to pass the background prop to specify a borderless ripple effect.
       */
      if (Platform.OS === 'android' && Platform.Version >= ANDROID_VERSION_LOLLIPOP) {
        var _this$props = this.props,
            style = _this$props.style,
            rest = _objectWithoutProperties(_this$props, ["style"]);

        return React.createElement(TouchableNativeFeedback, _extends({}, rest, {
          style: null,
          background: TouchableNativeFeedback.Ripple(this.props.pressColor, this.props.borderless)
        }), React.createElement(View, {
          style: style
        }, React.Children.only(this.props.children)));
      }

      return React.createElement(TouchableOpacity, this.props, this.props.children);
    }
  }]);

  return TouchableItem;
}(React.Component);

_defineProperty(TouchableItem, "defaultProps", {
  borderless: false,
  pressColor: 'rgba(0, 0, 0, .32)'
});

export { TouchableItem as default };